import { createRoute, useNavigate, useParams } from "@tanstack/react-router";
import { ClubGuard } from "@/components/ClubGuard";
import { useOrganizerClubs } from "@/lib/clubs/queries";
import { useVotingSession } from "@/lib/clubs/voting";
import { useBookDetail, useCreateRoom } from "@/lib/clubs/rooms";
import { RoomCreationForm } from "@/components/rooms/RoomCreationForm";
import { clubsRoute } from "./clubs";

function NewRoomRoute() {
  const params = useParams({ from: clubsRoomsNewRoute.id });
  const clubId = params.id;
  const navigate = useNavigate();

  const { data: clubs = [] } = useOrganizerClubs();
  const club = clubs.find((c) => c.id === clubId);

  const session = useVotingSession(clubId).data;
  const winnerBook = session?.winnerBook ?? null;

  const bookId = winnerBook?.id;
  const { data: book = null, isLoading: isBookLoading } = useBookDetail(bookId);

  const createRoom = useCreateRoom();

  return (
    <RoomCreationForm
      clubId={clubId}
      clubName={club?.name ?? "Club"}
      winnerBook={winnerBook}
      book={book}
      isBookLoading={isBookLoading && Boolean(bookId)}
      isSubmitting={createRoom.isPending}
      submitError={createRoom.error}
      onSubmit={(payload) => {
        createRoom.mutate(payload, {
          onSuccess: (room) => {
            navigate({
              to: "/clubs/$id/rooms/$roomId",
              params: { id: clubId, roomId: room.id },
            });
          },
        });
      }}
      onDiscard={() => navigate({ to: "/clubs/$id", params: { id: clubId } })}
    />
  );
}

export const clubsRoomsNewRoute = createRoute({
  getParentRoute: () => clubsRoute,
  path: "/$id/rooms/new",
  component: () => (
    <ClubGuard requireClubId>
      <NewRoomRoute />
    </ClubGuard>
  ),
});
